import React, { Dispatch, SetStateAction } from 'react';
import { CircularProgress } from '@mui/material';
import useMenuListHooks from './menuList-hook';
import {
  ICategoryAction,
  ICategoryItem,
  IMenuItemActions,
  MenuListContentTypes,
  MenuListTypes,
  MyMenuContentTypes,
} from '../../../../../../../Interfaces/componentTypes';
import { IMenuItemResponce, IMenuListItem, MenuListResponce } from '../../../../../../../Interfaces/responseTypes';
import NoData from '../../../../../../../Components/NoData/noData';
import useLanguagesHooks from '../../../../../../../Components/Languages/setLanguage-hooks';
import styles from './menuList.module.scss';

export interface IMenuListProps {
  type: MenuListTypes;
  menuLoading: boolean;
  menu: MenuListResponce;
  itemOrderList?: number[];
  itemActions?: IMenuItemActions[];
  categoryOrderList?: number[];
  contentType: MenuListContentTypes;
  categoryActions?: ICategoryAction[];
  categoryItems: ICategoryItem | null;
  companyTitle?: string;
  companyId: number;
  setActiveContent?: Dispatch<SetStateAction<MyMenuContentTypes>>;
  onCategoryOrderChange?: (updatedOrder: number[]) => void;
  onMenuItemOrderChange?: (updatedOrder: number[]) => void;
  setContentType: Dispatch<SetStateAction<MenuListContentTypes>>;
  onOpenAddMenuItemDialog?: (
    companyId: number,
    categoryId: number,
    title: string
  ) => void;
  onSetMenuItemList?: (data: IMenuListItem, title: string) => void;
  onOpenMenuItemInfoDialog?: (categoryId: number, data: IMenuItemResponce, title: string) => void;
  handleItemIsActive?: (categoryId: number, data: IMenuItemResponce) => void
}

const MenuList: React.FC<IMenuListProps> = (props) => {
  const { t } = useLanguagesHooks();
  const { type, contentType, menu, menuLoading, setActiveContent, } = props;
  const { sortedCategories, renderContent, renderHeader, } = useMenuListHooks(props);
  if (menuLoading) {
    return (
      <div className={styles.loadingContainer}>
        <CircularProgress sx={{ color: '#b00020' }} size="25px" />
      </div>
    );
  }

  if (!menu.length || !sortedCategories) {
    return (
      <NoData
        buttonTitle={t('Buttons.Create_Menu')}
        message={t('No_Data.Menu')}
        withButton={type === MenuListTypes.VIEW}
        onPressButton={()=>setActiveContent && setActiveContent(MyMenuContentTypes.EDIT_Menu)}
        containerStyle={styles.noDataBox}
      />
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.menuListBox}>
        {renderHeader()}
        <div
          className={`
             ${styles.menuListItems} 
            ${type === MenuListTypes.EDIT &&
               (contentType === MenuListContentTypes.ITEMS ?
                styles.menuListEditItem
                :
                styles.menuListEditCategory)
              }
              ${
                type === MenuListTypes.VIEW &&
               ( contentType === MenuListContentTypes.ITEMS ?
                styles.menuListViewItems
                :
                styles.menuListViewCategory)
              }
            `}
          style={{
            ...(type === MenuListTypes.EDIT && { columnGap:'10px'}),
          }}
        >
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default MenuList;
